export default __webpack_public_path__ + "static/media/Exterior8.dd6cc34a.jpg";